import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgChevronUp(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.589 7.58579C11.3704 6.80474 12.6372 6.80474 13.4186 7.58579L19.7108 13.8749C20.1015 14.2654 20.1015 14.8986 19.7108 15.2891C19.3201 15.6796 18.6866 15.6796 18.296 15.2891L12.0038 9L5.71161 15.2891C5.32092 15.6796 4.68749 15.6796 4.2968 15.2891C3.90611 14.8986 3.90611 14.2654 4.2968 13.8749L10.589 7.58579Z", fill: "currentColor" })));
}
export default SvgChevronUp;
